import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Buttons from '../Buttons';

const StyledToggleButton = styled(Buttons)`
  width: ${rem('30px')};
  height: ${rem('30px')};
  padding: ${rem('10px')} ${rem('8px')};
  position: absolute;
  top: ${rem('10px')};
  left: ${rem('0px')};
  svg {
    display: block;
    width: ${rem('12px')};
    height: ${rem('6px')};
    margin: 0;
    transform: rotateX(0deg);
    transition-timing-function: linear;
    transition-duration: 0.3s;
  }
  ${props =>
    props.expanded &&
    css`
      svg {
        fill: red;
        transform: rotateX(180deg);
      }
    `};
`;

const StyledPrimaryButton = styled(Buttons)`
  padding: ${rem('6px')};
  position: absolute;
  top: ${rem('14px')};
  right: ${rem('15px')};
  svg {
    width: ${rem('18px')};
    height: ${rem('18px')};
    margin: 0;
  }
  &:hover {
    svg {
      fill: ${props => props.theme.colors.primary};
    }
  }
`;

const StyledAccordionActions = styled.ul`
  border: solid ${rem('1px')} ${props => props.theme.colors.grayLight};
  margin: 0;
  padding: 0;
  list-style: none;
`;

const StyledAccordionActionsSecondary = styled.div`
  font-size: ${rem('14px')};
  display: block;
  overflow: hidden;
  height: auto;
  max-height: 0;
  min-height: 0;
  transition: all 0.3s ease;
  ${props =>
    props.expanded &&
    `
      max-height: ${rem('300px')};
      /* Este valor debe ser suficientemente alto para cubrir su altura */
    `};
`;

const StyledAccordionActionsTableInfo = styled.table`
  font-size: ${rem('14px')};
  margin: ${rem('3px')} ${rem('-10px')} 0;
  td,
  th {
    padding: ${rem('2px')} ${rem('10px')};
    font-weight: 500;
  }
  th {
    font-family: ${props => props.theme.fonts.medium};
  }
`;

const StyledAccordionActionsItem = styled.li`
  background-color: ${props => props.theme.colors.grayMoreLight};
  font-size: ${rem('14px')};
  padding: ${rem('17px')} ${rem('30px')} ${rem('14px')} ${rem('30px')};
  line-height: 1.4;
  cursor: pointer;
  position: relative;
  transition: background 0.3s ease;
  min-height: ${rem('70px')};
  &:not(:last-child) {
    border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  }
  &:before {
    content: none;
  }
  &:hover {
    ${StyledToggleButton}, ${StyledPrimaryButton} {
      svg {
        fill: ${props => props.theme.colors.primary};
      }
    }
  }
  ${props =>
    props.expanded &&
    css`
      background-color: ${props.theme.colors.grayLightest};
      ${StyledAccordionActionsSecondary} {
        max-height: ${rem('200px')};
      }
    `};
`;

const StyledItemPrimaryAvatarContent = styled.div`
  width: ${rem('38px')};
  height: ${rem('38px')};
  border: solid ${rem('2px')} ${props => props.theme.colors.grayDarkest};
  border-radius: 50%;
  top: ${rem('14px')};
  right: ${rem('15px')};
  position: absolute;
`;

const StyledAccordionActionsTitle = styled.span`
  font-family: ${props => props.theme.fonts.medium};
  display: block;
`;

const StyledAccordionActionsPrimary = styled.div`
  padding-right: ${rem('18px')};

  ${props =>
    props.type === 'avatar' &&
    `
      padding-right: ${rem('35px')};
      max-width: ${rem('270px')};
    `};
`;

export {
  StyledAccordionActions,
  StyledAccordionActionsItem,
  StyledAccordionActionsPrimary,
  StyledAccordionActionsTitle,
  StyledItemPrimaryAvatarContent,
  StyledToggleButton,
  StyledPrimaryButton,
  StyledAccordionActionsSecondary,
  StyledAccordionActionsTableInfo
};
